import script from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=b090d8ec&scoped=true&lang=css"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b090d8ec"]])

export default __exports__